import { WalletIcon } from '@heroicons/react/24/outline'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useNotificationContext, useUserContext } from '../../../context'
import { isSampleCareer, isSampleSpace } from '../../../helpers/sample-data'
import { useDiscover } from '../hooks/useDiscover'
import { useSelectionParams } from '../hooks/useSelectionParams'
import { EVALUATION_CONTEXT } from '../utils'
import TalentBadge from './TalentBadge'
import InfoCard from './talentMatch/InfoCard'

export default function InfoCardPair({ career, talent, isLoading }) {
  const { t } = useTranslation()
  const { success, error } = useNotificationContext()
  const { activeSpace } = useUserContext()
  const { removeCareer, removeTalent } = useSelectionParams()
  const { selectedResult } = useDiscover()

  const hasCompletedOnboarding = activeSpace?.hasCompletedOnboarding
  const talentName = talent?.person
    ? `${talent.person.firstname || talent.person.invitation_firstname} ${talent.person.lastname || talent.person.invitation_lastname}`
    : t('common.unknown_talent')

  const onIdClick = (_, copied) => {
    if (copied) success(t('common.copy_success'))
    else error(t('global.copy_error'))
  }

  return (
    <div
      className='info-card-pair relative mt-4 flex flex-row gap-x-2'
      id='talent-match-info-card'
    >
      <InfoCard
        icon={<WalletIcon className='size-5 text-darkBlue' />}
        title={career.title}
        id={career.id}
        idLabel={t('discover.match_overview_section.career_id', {
          career_id: ''
        }).replace(': ', '')}
        idTooltip={`${t('discover.match_overview_section.talent_id_full')}: ${career.id} (${t('discover.match_overview_section.click_to_copy')})`}
        onIdClick={onIdClick}
        isDemo={isSampleCareer(career)}
        onClickRemove={() => removeCareer(career.id)}
        onClickRemoveToolTip={t(
          'discover.match_overview_section.remove_career_tooltip'
        )}
        hasCompletedOnboarding={hasCompletedOnboarding}
        isLoading={isLoading}
        disabled={selectedResult === EVALUATION_CONTEXT.TALENTPROFILE}
      />

      <InfoCard
        icon={<TalentBadge talentName={talentName} />}
        title={talentName}
        id={talent.id}
        idLabel={t('discover.match_overview_section.talent_id', {
          talent_id: ''
        }).replace(': ', '')}
        idTooltip={`${t('discover.match_overview_section.talent_id_full')}: ${talent.id} (${t('discover.match_overview_section.click_to_copy')})`}
        onIdClick={onIdClick}
        isDemo={isSampleSpace(talent)}
        sampleKind='talent'
        onClickRemove={() => removeTalent(talent.id)}
        onClickRemoveToolTip={t(
          'discover.match_overview_section.remove_talent_tooltip'
        )}
        hasCompletedOnboarding={hasCompletedOnboarding}
        isLoading={isLoading}
        disabled={selectedResult === EVALUATION_CONTEXT.REQUIREMENTPROFILE}
      />

      {selectedResult === EVALUATION_CONTEXT.MATCHINGPROFILE && (
        <div
          style={{
            borderTopWidth: 2,
            borderBottomWidth: 2
          }}
          className='absolute left-1/2 top-1/2 z-[10] h-[38px] w-3 -translate-x-1/2 -translate-y-1/2 border-softGrey bg-white'
        />
      )}
    </div>
  )
}

InfoCardPair.propTypes = {
  career: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string
  }),
  talent: PropTypes.shape({
    id: PropTypes.string,
    person: PropTypes.shape({
      firstname: PropTypes.string,
      invitation_firstname: PropTypes.string,
      lastname: PropTypes.string,
      invitation_lastname: PropTypes.string
    })
  }),
  isLoading: PropTypes.bool
}
